var EmptyDiagramModel = /** @class */ (function () {
    function EmptyDiagramModel() {
        this._model = JSON.parse('{ "class": "go.GraphLinksModel", "nodeDataArray": [], "linkDataArray": [], "modelData": {} }');
    }
    EmptyDiagramModel.prototype.setViewSettings = function (v) {
        this._model.modelData.settings = v;
    };
    Object.defineProperty(EmptyDiagramModel.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    return EmptyDiagramModel;
}());
export { EmptyDiagramModel };
